import { handleActions } from 'redux-actions';
export default handleActions({
  SET_SCOPE: function SET_SCOPE(_state, action) {
    return action.payload;
  }
}, '');